import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Links from './links';
import Branding from './branding';
import Inner from './inner';

const SubFooter = ({ className }) => (
  <div className={className}>
    <Container>
      <Inner>
        <Branding />
        <Links />
      </Inner>
    </Container>
  </div>
);

export default styled(SubFooter)`
  background-color: ${({ theme }) => theme.subFooterBgColor || theme.grayDarkColor};
  padding: 1rem 0;
  text-align: center;
`;
